import OpenGraphResource from 'flow/api/opengraph';
import Actions from 'flow/actions';

import { httpGetErrorDispatcher } from 'flow/actions/app-actions';

// Used to associate several urls with the same key in the list of query params
const queryParamSeparator = '&openGraphUrls=';

export const fetchOpenGraphData = (urlList, callback) => {
    return (dispatch) => {
        const queryParams = urlList
            .map((url) => encodeURIComponent(url))
            .join(queryParamSeparator);

        OpenGraphResource.getOpenGraphData(
            {
                onResult: function onResult(openGraphDTOs) {
                    dispatch(receiveOpenGraphData(urlList, openGraphDTOs));
                    if (callback) {
                        callback();
                    }
                },
                onError: httpGetErrorDispatcher(dispatch),
            },
            queryParams,
        );
    };
};

const receiveOpenGraphData = (urlList, openGraphDTOs) => ({
    type: Actions.RESULT_OPEN_GRAPH_DATA,
    urlList: urlList,
    data: openGraphDTOs,
});
